var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let BasicTab = class BasicTab extends LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
        this.selectedValue = '';
        this.size = 'medium';
        this.variant = 'primary';
        this.special = false;
    }
    onTabClick(value) {
        this.selectedValue = value;
        this.dispatchEvent(new CustomEvent('tab-change', { detail: { value } }));
    }
    render() {
        return html `
      <div class="tab-container">
        ${this.options.map((opt) => html `
            <div
              class="
                tab
                size-${this.size}
                variant-${this.variant}
                ${this.special ? 'special' : ''}
              "
              ?selected=${this.selectedValue === opt.value}
              @click=${() => this.onTabClick(opt.value)}
            >
              ${opt.label}
            </div>
          `)}
      </div>
      <div class="tab-content">
        <slot name="${this.selectedValue}"></slot>
      </div>
    `;
    }
};
BasicTab.styles = css `
    :host {
      display: block;
      font-family: inherit;
    }

    /* --- Container --- */
    .tab-container {
      display: flex;
      border-bottom: 2px solid #ccc; /* Ligne unique propre */
      gap: 4px;
    }

    /* --- Base tab styles --- */
    .tab {
      cursor: pointer;
      border: none;
      border-bottom: 2px solid transparent;
      background: transparent;
      transition: background 0.25s, color 0.25s, border-color 0.25s;
      font-weight: 600;
    }

    .tab:hover {
      background: #f7f7f7;
    }

    .tab[selected] {
      border-bottom: 2px solid currentColor;
    }

    /* --- Sizes --- */
    .size-small {
      padding: 6px 12px;
      font-size: 12px;
    }

    .size-medium {
      padding: 8px 16px;
      font-size: 14px;
    }

    .size-large {
      padding: 10px 20px;
      font-size: 18px;
    }

    /* --- Variants (text colors) --- */
    .variant-primary {
      color: #0078d4;
    }
    .variant-primary[selected] {
      color: #005a9e;
    }

    .variant-secondary {
      color: #666;
    }

    .variant-success {
      color: #28a745;
    }

    .variant-danger {
      color: #dc3545;
    }

    .variant-warning {
      color: #cc9a06;
    }

    /* --- Special gradient underline --- */
    .special[selected] {
      background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(255,255,255,0) 100%);
      border-bottom-width: 3px;
      border-image-slice: 1;
    }

    .special.variant-primary[selected] {
      border-image-source: linear-gradient(90deg, #0078d4, #00aaff);
    }
    .special.variant-secondary[selected] {
      border-image-source: linear-gradient(90deg, #aaaaaa, #e0e0e0);
    }
    .special.variant-success[selected] {
      border-image-source: linear-gradient(90deg, #28a745, #5cd65c);
    }
    .special.variant-danger[selected] {
      border-image-source: linear-gradient(90deg, #dc3545, #ff6f71);
    }
    .special.variant-warning[selected] {
      border-image-source: linear-gradient(90deg, #ffc107, #ffe066);
    }

    .tab-content {
      padding: 16px 0;
    }
  `;
__decorate([
    property({ type: Array })
], BasicTab.prototype, "options", void 0);
__decorate([
    property({ type: String })
], BasicTab.prototype, "selectedValue", void 0);
__decorate([
    property({ type: String })
], BasicTab.prototype, "size", void 0);
__decorate([
    property({ type: String })
], BasicTab.prototype, "variant", void 0);
__decorate([
    property({ type: Boolean })
], BasicTab.prototype, "special", void 0);
BasicTab = __decorate([
    customElement('basic-tab')
], BasicTab);
export { BasicTab };
//# sourceMappingURL=BasicTab.js.map